import { render, staticRenderFns } from "./UnorderedList.vue?vue&type=template&id=71e776fa&"
import script from "./UnorderedList.vue?vue&type=script&lang=js&"
export * from "./UnorderedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports